import { FC } from "react";

import { List } from "antd";

import { ISampleType } from "@/models/SampleType";
import SampleTypeItem from "../SampleTypeItem";

interface SampleTypeListProps {
  sampleTypeList: ISampleType[];
  editSampleType: (id: number, type: string) => void;
  deleteSampleType: (id: number) => void;
}

const SampleTypeList: FC<SampleTypeListProps> = ({
  sampleTypeList,
  editSampleType,
  deleteSampleType,
}) => {
  return (
    <List
      size="small"
      bordered
      dataSource={sampleTypeList}
      renderItem={(item) => (
        <List.Item>
          <SampleTypeItem
            sampleType={item}
            editSampleType={editSampleType}
            deleteSampleType={deleteSampleType}
          />
        </List.Item>
      )}
    />
  );
};

export default SampleTypeList;
